import { Store } from 'vuex';

export function getterFromPath(path: string | undefined, store: Store<unknown>) {
    if (!path) {
        return null;
    }
    const value = store.getters[path];
    return value ? `${value}` : null;
}
